import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/i18n";
import { api } from "@/lib/api";

const CHEF_IMG = "https://images.unsplash.com/photo-1572552635104-daf938e0aa1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwxfHxwaXp6YSUyMGNoZWYlMjB3b3JraW5nfGVufDB8fHx8MTc4NjcyNTMwMnww&ixlib=rb-4.1.0&q=85";

export function Manifesto() {
  const { t } = useLang();
  const [sectionImg, setSectionImg] = useState(CHEF_IMG);
  useEffect(() => {
    api.get("/site-images").then((r) => {
      const u = r.data?.manifesto;
      if (u) setSectionImg(u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
    }).catch(() => {});
  }, []);
  return (
    <section id="filosofia" data-testid="manifesto-section" className="py-28 lg:py-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.p
          className="text-xs uppercase tracking-[0.35em] text-[#555] mb-6"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.8 }}
        >
          {t.manifesto.overline}
        </motion.p>
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-start">
          <div>
            <motion.h2
              data-testid="manifesto-title"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight max-w-md"
              initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }} transition={{ duration: 0.9, delay: 0.1 }}
            >
              {t.manifesto.title}
            </motion.h2>
            <motion.div
              className="mt-14 hidden lg:block"
              initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }} transition={{ duration: 1, delay: 0.2 }}
            >
              <div className="w-full max-w-sm overflow-hidden">
                <img src={sectionImg} alt="Il pizzaiolo al lavoro" className="w-full aspect-[3/4] object-cover hover:scale-105 transition-transform duration-700" />
              </div>
            </motion.div>
          </div>
          <div>
            {t.manifesto.chapters.map((c, i) => (
              <motion.div
                key={c.n}
                data-testid={`manifesto-chapter-${c.n}`}
                className="border-t border-[#E5E5E5] py-10 flex gap-8 group"
                initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.8, delay: i * 0.12 }}
              >
                <span className="font-serif italic text-4xl text-[#6B1E33] leading-none">{c.n}</span>
                <div>
                  <h3 className="font-serif text-2xl mb-2 group-hover:text-[#6B1E33] transition-colors duration-300">{c.t}</h3>
                  <p className="font-serif italic text-[#6B1E33] mb-3">{c.s}</p>
                  <p className="text-sm text-[#555] leading-relaxed max-w-md">{c.d}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
